import { render, staticRenderFns } from "./AllenamentoFeedbackItem.vue?vue&type=template&id=14f23eec"
import script from "./AllenamentoFeedbackItem.vue?vue&type=script&lang=js"
export * from "./AllenamentoFeedbackItem.vue?vue&type=script&lang=js"
import style0 from "./AllenamentoFeedbackItem.vue?vue&type=style&index=0&id=14f23eec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports